var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import FileCollectionForm from '@backoffice/components/file/FileCollectionForm.vue';
import { isFileCollectionModelField, isFileModelField, ModelFieldInputType, } from '@shared/modelField/modelField';
import { dateToISOLocaleDay, dateToISOLocaleDayAndTime, optionalValueToDate, } from '@shared/utils/date';
import { EMPTY } from '@shared/utils/strings';
let ModelFieldControl = class ModelFieldControl extends Vue {
    constructor() {
        super(...arguments);
        this.empty = EMPTY;
        this.ModelFieldInputType = ModelFieldInputType;
        this.internalValue = null;
        this.submittedValue = null;
        this.multipleValue = [];
    }
    get editionConfiguration() {
        var _a;
        return (_a = this.field.editable) !== null && _a !== void 0 ? _a : null;
    }
    get inputType() {
        var _a, _b;
        return (_b = (_a = this.editionConfiguration) === null || _a === void 0 ? void 0 : _a.input.type) !== null && _b !== void 0 ? _b : ModelFieldInputType.Text;
    }
    get inputTypeAttr() {
        switch (this.inputType) {
            case ModelFieldInputType.Age:
            case ModelFieldInputType.Amount:
                return 'number';
            case ModelFieldInputType.DateTime:
                return 'datetime-local';
            case ModelFieldInputType.MultipleChoice:
                return 'checkbox';
            case ModelFieldInputType.FileCollection:
                return 'file';
            default:
                return `${this.inputType}`;
        }
    }
    get label() {
        var _a;
        if (this.inline)
            return undefined;
        const { label = this.field.label, unit } = (_a = this.editionConfiguration) !== null && _a !== void 0 ? _a : {};
        if (unit)
            return `${label} (${unit})`;
        return label;
    }
    get placeholder() {
        var _a, _b;
        switch ((_a = this.editionConfiguration) === null || _a === void 0 ? void 0 : _a.input.type) {
            case ModelFieldInputType.Select:
            case ModelFieldInputType.Radio:
                return (_b = this.editionConfiguration.input.placeholder) !== null && _b !== void 0 ? _b : undefined;
            default:
                return undefined;
        }
    }
    get value() {
        var _a;
        switch ((_a = this.editionConfiguration) === null || _a === void 0 ? void 0 : _a.input.type) {
            case ModelFieldInputType.Amount:
                return this.field.value === null ? '' : parseInt(this.field.value) / 100;
            case ModelFieldInputType.Number:
                return this.field.value === null ? '' : this.field.value;
            default:
                return this.field.value;
        }
    }
    get choices() {
        var _a;
        switch ((_a = this.editionConfiguration) === null || _a === void 0 ? void 0 : _a.input.type) {
            case ModelFieldInputType.MultipleChoice:
            case ModelFieldInputType.Select:
            case ModelFieldInputType.Radio:
                return this.editionConfiguration.input.choices;
            default:
                return [];
        }
    }
    get isFile() {
        return isFileModelField(this.field);
    }
    get isFileCollection() {
        return isFileCollectionModelField(this.field);
    }
    get isCheckbox() {
        return this.inputType === ModelFieldInputType.Checkbox;
    }
    get isMultipleChoice() {
        return this.inputType === ModelFieldInputType.MultipleChoice;
    }
    get isSelect() {
        return this.inputType === ModelFieldInputType.Select;
    }
    get isRadio() {
        return this.inputType === ModelFieldInputType.Radio;
    }
    get isDate() {
        return this.inputType === ModelFieldInputType.Date;
    }
    get isDateTime() {
        return this.inputType === ModelFieldInputType.DateTime;
    }
    get isAge() {
        return this.inputType === ModelFieldInputType.Age;
    }
    get isNullable() {
        var _a, _b;
        switch ((_a = this.editionConfiguration) === null || _a === void 0 ? void 0 : _a.input.type) {
            case ModelFieldInputType.Radio:
                return (_b = this.editionConfiguration.input.nullable) !== null && _b !== void 0 ? _b : false;
            default:
                return undefined;
        }
    }
    get isVertical() {
        var _a, _b;
        switch ((_a = this.editionConfiguration) === null || _a === void 0 ? void 0 : _a.input.type) {
            case ModelFieldInputType.Radio:
            case ModelFieldInputType.MultipleChoice:
                return (_b = this.editionConfiguration.input.vertical) !== null && _b !== void 0 ? _b : false;
            default:
                return undefined;
        }
    }
    created() {
        this.$watch('value', (value) => {
            this.internalValue = value;
            this.submittedValue = value;
            this.multipleValue = value;
        }, { immediate: true });
        this.$watch('multipleValue', (multipleValue) => {
            if (this.multipleValue === this.internalValue) {
                return;
            }
            this.onInput(multipleValue);
            this.onBlur();
        });
    }
    get ageYearsValue() {
        if (typeof this.internalValue !== 'number')
            return 0;
        if (this.ageInYears)
            return this.internalValue;
        else
            return Math.floor(this.internalValue / 12);
    }
    set ageYearsValue(ageYearsValue) {
        if (this.ageInYears)
            this.onInput(ageYearsValue);
        else
            this.onInput(this.ageMonthsValue + ageYearsValue * 12);
    }
    get ageMonthsValue() {
        if (typeof this.internalValue !== 'number' || this.ageInYears)
            return 0;
        else
            return this.internalValue % 12;
    }
    set ageMonthsValue(ageMonthsValue) {
        if (!this.ageInYears)
            this.onInput(ageMonthsValue + this.ageYearsValue * 12);
    }
    get ageInYears() {
        var _a, _b;
        if (((_a = this.editionConfiguration) === null || _a === void 0 ? void 0 : _a.input.type) === ModelFieldInputType.Age) {
            return !!((_b = this.editionConfiguration) === null || _b === void 0 ? void 0 : _b.input.yearsOnly);
        }
        return false;
    }
    get dateValue() {
        if (!this.internalValue) {
            return null;
        }
        return new Date(this.internalValue);
    }
    get dateMin() {
        return ((this.field.editable &&
            'min' in this.field.editable.input &&
            optionalValueToDate(this.field.editable.input.min)) ||
            null);
    }
    get dateMax() {
        return ((this.field.editable &&
            'max' in this.field.editable.input &&
            optionalValueToDate(this.field.editable.input.max)) ||
            null);
    }
    dateToHtmlAttr(date) {
        var _a, _b;
        if (!date) {
            return null;
        }
        if (((_a = this.field.editable) === null || _a === void 0 ? void 0 : _a.input.type) === ModelFieldInputType.DateTime) {
            return dateToISOLocaleDayAndTime(date);
        }
        if (((_b = this.field.editable) === null || _b === void 0 ? void 0 : _b.input.type) === ModelFieldInputType.Date) {
            return dateToISOLocaleDay(date);
        }
        return null;
    }
    get fileCollectionDisplayedValue() {
        return this.field.displayedValue;
    }
    get isDisabled() {
        var _a;
        return this.disabled || !!((_a = this.field.editable) === null || _a === void 0 ? void 0 : _a.disabled);
    }
    get validationFieldType() {
        if (!this.validation ||
            !this.editionConfiguration ||
            this.validation.fieldIsValid(this.editionConfiguration.modelKey)) {
            return '';
        }
        return 'is-danger';
    }
    get validationErrorMessages() {
        if (!this.validation || !this.editionConfiguration) {
            return null;
        }
        return this.validation.fieldErrors(this.editionConfiguration.modelKey, this);
    }
    onCheckboxInput(value) {
        this.onInput(value);
        this.onBlur();
    }
    onSelectInput(value) {
        this.onInput(value);
        this.onBlur();
    }
    onDatepickerInput(value) {
        this.onInput(value);
        this.onBlur();
    }
    onInput(value) {
        var _a;
        const editionConfiguration = this.editionConfiguration;
        if (!editionConfiguration) {
            return this.update(value);
        }
        const castTo = (_a = ('castTo' in editionConfiguration.input && editionConfiguration.input.castTo)) !== null && _a !== void 0 ? _a : null;
        if (editionConfiguration.input.type === ModelFieldInputType.Checkbox) {
            return this.update(!!value);
        }
        if (castTo === 'boolean') {
            if (typeof value === 'string') {
                return this.update(value === 'true');
            }
            return this.update(!!value);
        }
        if (editionConfiguration.input.type === ModelFieldInputType.Number || castTo === 'number') {
            return this.update(value.trim() === '' ? null : parseFloat(value));
        }
        if (editionConfiguration.input.type === ModelFieldInputType.Amount) {
            return this.update(value * 100);
        }
        if (editionConfiguration.input.type === ModelFieldInputType.Date ||
            editionConfiguration.input.type === ModelFieldInputType.DateTime) {
            return this.update(value.toISOString());
        }
        this.update(value);
    }
    onFileCollectionUpdate(event) {
        this.update(event);
        this.submit();
    }
    onBlur() {
        if (this.submittedValue !== this.internalValue) {
            this.submit();
        }
    }
    update(value) {
        this.internalValue = value;
        this.$emit('update', value);
    }
    submit() {
        this.submittedValue = this.internalValue;
        this.$emit('submit', this.internalValue);
    }
};
__decorate([
    Prop({ type: Object, required: true })
], ModelFieldControl.prototype, "field", void 0);
__decorate([
    Prop({ type: Object, default: null })
], ModelFieldControl.prototype, "validation", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ModelFieldControl.prototype, "inline", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ModelFieldControl.prototype, "disabled", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ModelFieldControl.prototype, "required", void 0);
ModelFieldControl = __decorate([
    Component({ components: { FileCollectionForm } })
], ModelFieldControl);
export default ModelFieldControl;
